import {Dialog, DialogContent} from "@mui/material";
import {styled} from "@mui/material/styles";
import {DoctorList} from "./DoctorList";


const CustomizedDialog = styled(Dialog)`
  & .MuiDialog-paper {
    width: 100%;
    min-height: 400px;
    //height: 320px;
    max-width: 100%;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    //padding: 24px 16px 34px;
  }

  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }

  & .MuiDialogContent-root {
    padding: 0
  }`;

export const DoctorsModal = (props) => {
    const {open, setOpen} = props
    const handleClose = () => {
        setOpen(false)
    }

    return (
        <CustomizedDialog
            open={open}
            onClose={handleClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <div>
                <DialogContent>
                    <DoctorList {...props}/>
                </DialogContent>
            </div>
        </CustomizedDialog>
    )
}